import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import { fetchLeadReportsDataForDownload, invalidateLeadsDownloadData } from "actions/leads";

import _ from 'lodash';
import dateformat from "dateformat";
import { Button } from "react-bootstrap";
import cx from 'classnames';

import { padNumber } from 'services/util';
import { convertDatesToTimezone } from 'services/report.service';

import { CSVLink } from "react-csv";

import styles from '../leadReports.module.scss';

export function LeadSummary(props) {

  const page = useSelector(state => _.get(state, 'storyboards.storyboard.item.page', {}));
  const published = useSelector(state => _.get(state, 'storyboards.storyboard.item.page.published', {}));

  return (
    <div className={styles.summary}>
      <div className={styles.summaryHeading}>
        <div className={styles.left}>
          <h1 className={styles.leadsHeading}>Leads</h1>
          <span className={styles.leadsDescription}>A telescopic view of how your content is performing</span>
        </div>

        <div className={styles.right}>
          <ExportCSV date={props.date} />
          <div className={styles.creator}>
            <span className={styles.heading}>Created by: </span>
            <span className={styles.value}>{_.get(page, 'createdBy.firstName') || ''} {_.get(page, 'createdBy.lastName') || ''}</span>
          </div>

          <div className={styles.updatedInfo}>
            {published && <>
              <div className={styles.published}>
                <span className={styles.heading}>Published: </span>
                <span className={styles.value}>{dateformat(page.lastPublished, 'dd mmm yyyy')}</span>
              </div>
              |
            </>
            }

            <div className={cx({ [styles.modified]: published })}>
              <span className={styles.heading}>Modified: </span>
              <span className={styles.value}>{dateformat(page.modifiedDate, 'dd mmm yyyy')}</span>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  )
}

function ExportCSV(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  let downloads = useSelector(state => _.get(state, 'lead.downloads.items'));
  const completed = useSelector(state => _.get(state, 'lead.downloads.completed'));
  const progress = useSelector(state => _.get(state, 'lead.downloads.progress'));
  const [csvData, setCsvData] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const csvLink = useRef();

  const headers = [
    { label: "Lead & Account", key: "leadAccount" },
    { label: "Source", key: "source" },
    { label: "Campaign", key: "campaign" },
    { label: "Created Date", key: "createdDate" },
    { label: "Last Visited", key: "lastVisitedDate" },
    { label: "Views", key: "views" },
    { label: "Time Spent", key: "time_spent" },
    { label: "Completion", key: "completion" }
  ];

  const renderVisitorName = (data) => {
    var name = `${_.get(data, 'firstName') || ''} ${_.get(data, 'lastName') || ''} `;
    return name;
  }

  const renderTimeSpent = (seconds) => {
    let minutes = padNumber(Math.floor(seconds / 60), 2);
    seconds = padNumber(Math.floor(seconds % 60), 2);
    var hours = padNumber(Math.floor(minutes / 60), 2);
    minutes = padNumber(minutes % 60, 2);

    hours = hours > 0 ? `${hours}:` : ''
    return `${hours}${minutes}:${seconds}`;
  }

  useEffect(() => {
    if (completed) {
      var columns = [];
      downloads && _.uniqBy(downloads, 'contact.id').map((data, index) => {
        columns[index] = {
          leadAccount: renderVisitorName(data.contact),
          source:  data.campaignSource ,
          campaign:  data.campaignName ,
          createdDate: dateformat(data.contact.createdDate, 'dd mmm yyyy'),
          lastVisitedDate: dateformat(data.lastVisitedDate, 'dd mmm yyyy'),
          views: data.views,
          time_spent: renderTimeSpent(data.timeSpent),
          completion: `${Math.round(data.completion)} %`
        }
      });

      setCsvData(columns);
    }
  }, [completed]);

  useEffect(() => {
    if ( csvData && csvData.length == 0) {
      return;
    }

    csvLink.current.link.click();

    return () => {
      dispatch(invalidateLeadsDownloadData());
    }
  }, [csvData]);

  const handleFetchLeadsReport = () => {
    var request = {
      storyboard: storyboardId,
      metricType: "leads",
      ...convertDatesToTimezone(props.date),
    }

    dispatch(fetchLeadReportsDataForDownload(request, 0, 1));
  }

  return (
    <div>
      <Button variant="primary" disabled={progress} onClick={handleFetchLeadsReport} className={styles.download}>
        <span className={styles.name}>{progress ? "Downloading..." : "Download"}</span>
        <i className={cx("cleverstory-download", styles.downloadIcon)} />
      </Button>
      <CSVLink
        ref={csvLink}
        headers={headers}
        data={csvData}
        filename='Reports.csv'
        className='hidden'
      />
    </div>
  )
}